import * as actions from './actions';

import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { AjaxResponse } from 'rxjs/ajax';
import { Epic } from 'redux-observable';
import { GetResourceTimeRangesAPIResponse } from './types';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';

export const getResourceTimeRangesEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getResourceTimeRanges.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      return apiClient(state)
        .getResourceTimeRanges(payload)
        .pipe(
          map(({ response }: AjaxResponse<GetResourceTimeRangesAPIResponse>) => {
            return actions.getResourceTimeRanges.success({
              time_ranges: response.data.time_ranges,
              preset_bookable_windows: response.data.preset_bookable_windows,
            });
          }),
          catchError((error: Error) => of(actions.getResourceTimeRanges.failure({ error }))),
        );
    }),
  );
